import { useHistory } from "react-router-dom";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen los botones de la barra de navegación.
================================================================================ */
export default function MenuItems() {
    let history = useHistory();
    const items = [
        {
            label: 'Empresa',
            index: 0,
            path: "/CompanyInfo"
        },
        {
            label: 'Bancos',
            index: 1,
            path: "/Banks"
        },
        {
            label: 'Firma',
            index: 2,
            path: "/Firms"
        },
        {
            label: 'Cargo',
            index: 3,
            path: "/Jobs"
        },
        {
            label: 'Contable',
            index: 4,
            path: "/Accountant"
        },
        {
            label: 'Nómina',
            index: 5,
            path: "/Payroll"
        },
        {
            label: 'Ingresos y retenciones',
            index: 6,
            path: "/CIR"
        },
        {
            label: 'Habilitación DIAN',
            index: 7,
            path: "/ProcessDIAN"
        },
        {
            label: 'Documentos',
            index: 8,
            path: "/DocumentAdmin"
        },
        {
            label: 'Planes',
            index: 9,
            path: "/Plans"
        },
        {
            label: 'Flujo aprobación solicitudes',
            index: 10,
            path: "/ApprovalFlow",
            icon: (localStorage.getItem('novelties') === 'N' && localStorage.getItem('tracking') === 'N') && "pi pi-lock",
        },
        {
            label: 'Configuración turnos',
            index: 11,
            path: "/ShiftConfiguration",
            icon: (localStorage.getItem('tracking') === 'N') && "pi pi-lock",
        },
    ]
    return items
}
